import { Component, Input, OnInit } from '@angular/core';
import { AjaxService } from '../../../services/ajax.service';
import { BannerService } from '../../../services/banner.service';
import { Utility } from '../../../shared/utility/utility';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-cashier-banner',
  templateUrl: './cashier-banner.component.html',
  styleUrls: ['./cashier-banner.component.scss']
})
export class CashierBannerComponent implements OnInit {

  bannerContent;
  @Input() zoneId;
  constructor(private utils:Utility, private bannerService:BannerService) { }

  ngOnInit(): void {
    if(this.zoneId)
    this.initiateCashierBanner();
  }

 async initiateCashierBanner(){
    let bannerRequest = { 'zoneId': this.zoneId };
    if (this.utils.getAffliateId('affiliate')) {
      bannerRequest["affiliateId"] = this.utils.getAffliateId('affiliate');
    }
    if(this.bannerService?.cashierBanners && this.bannerService?.cashierBanners[this.zoneId]){
      if(this.bannerService?.cashierBanners[this.zoneId][0].bannerType == 'Not_Logged_in' && this.utils.isUserLoggedIn()){
        this.bannerService.cashierBanners = {};
      }
    }
    
    if(this.bannerService?.cashierBanners && this.bannerService?.cashierBanners[this.zoneId]){
      this.updateCashierBanner(this.bannerService?.cashierBanners[this.zoneId]);
    }else{
      this.bannerService.cashierBanners = {};
      let banners = await this.bannerService.getBanners(bannerRequest)
      this.updateCashierBanner(banners);
    }
  }
  updateCashierBanner(banners){
    if(banners?.length){
      this.bannerService.cashierBanners[this.zoneId] = banners; 
      this.bannerContent = banners[0]?.content
    }else{
      this.bannerContent = null;
      this.bannerService.cashierBanners[this.zoneId] = null;
    }
  }
}
